import { ItemAvailabilityStatus } from 'enums/menu';
import { useMapToFrontendCartEntry } from 'state/order/hooks/use-map-to-frontend-cart-entry';
import { routes } from 'utils/routing';

/**
 *
 * Returns a function to reorder a previous order.
 */
export const useHandleReorder = ({
  addToCart,
  navigate,
  setPendingReorder,
  setReordering,
  storeHasSelection,
  setUnavailableCartEntries,
}) => {
  const mapBackendToFrontend = useMapToFrontendCartEntry();

  return async (order, url = routes.orders) => {
    if (order && storeHasSelection) {
      setReordering(true);
      const { reorderCartEntries } = order.cart;

      const unavailableEntries = [];

      for (const entry of reorderCartEntries) {
        // Map backend entry to frontend
        const { cartEntry: frontendEntry, status } = await mapBackendToFrontend(entry);
        // Check if the item is available
        if (status === ItemAvailabilityStatus.AVAILABLE) {
          addToCart(frontendEntry);
        } else {
          unavailableEntries.push(frontendEntry);
        }
      }

      if (unavailableEntries.length) {
        setUnavailableCartEntries(unavailableEntries);
      }

      setReordering(false);
      setPendingReorder(null);

      if (unavailableEntries.length === 0) {
        navigate(routes.cart);
      } else {
        // Navigate to the url provided if there are unavailable items
        navigate(url);
      }
    } else {
      // if there's no order or no order or store selection, navigate to where was initially intended
      navigate(url);
    }
  };
};
